module.exports = __webpack_public_path__ + "static/media/chrome-logo.b4002e70.png";